import { Directive, HostBinding, Input, OnChanges, SimpleChanges} from '@angular/core';

@Directive({
    selector: '[loading]',
    standalone: true
})

export class ButtonLoaderDirective implements OnChanges {
  @Input('loading') loading = false;

  @HostBinding('class.is-loading')
  protected get isLoading(): boolean {
    return this.loading;
  }

  @HostBinding('disabled')
  protected get isDisabled(): boolean {
    return this.loading;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.loading?.currentValue !== changes.loading?.previousValue) {
      // State is managed by HostBindings
    }
  }

}
